// @flow

import React, { type Node } from 'react';
import { getSafeGatewayVoucherCode, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import styled from 'styled-components';
import { formatCashCode } from '@tectonics/prs/cash-mexico';

export function PaynetNumber(): Node {
  const incomingPayment = usePendingIncomingPayment();

  return (
    <BarcodeNumber>
      {formatCashCode(getSafeGatewayVoucherCode(incomingPayment))}
    </BarcodeNumber>
  );
}

const BarcodeNumber = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #737f93;
`;
